export const APP_IMAGES_URL = 'https://i.oddsocean.com'